import $ from 'jquery';
import cart from '@ppcp/cart';
import Actions from '@ppcp/actions';

const actions = new Actions();

cart.on('product_button_on_init', () => {
    $('.wc-stripe-product-checkout-container').addClass('active');
});

cart.on('cart_button_on_init', () => {
    $('.wc_stripe_cart_payment_methods').addClass('active');
});

cart.on('expressCheckoutButtonOnInit', () => {
    $('.banner_payment_method_ppcp').addClass('active');
    $('.banner_payment_method_ppcp').closest('.wc-stripe-banner-checkout').addClass('active');
});

actions.addAction('payment_element_ready', (controller) => {
    if (controller.context.isExpressCheckout()) {
        $('.banner_payment_method_ppcp').closest('.wc-stripe-banner-checkout').addClass('active');
    } else if (controller.context.isCart()) {
        $('.wc_stripe_cart_payment_methods').addClass('active');
    } else if (controller.context.isProduct()) {
        $('.wc-stripe-product-checkout-container').addClass('active');
    }
});